const awsExportAlpha = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:be7e4e95-33c6-4988-8b3c-98c623ccc9ca',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_Vp2qnVpzL',
  aws_user_pools_web_client_id: '5qlfncnee1s27mlsqm2h7ct8ug',
  oauth: {
    domain: 'biocare-alpha.auth.us-east-2.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'https://mercy.alpha.bioflux.io/',
    redirectSignOut: 'https://mercy.alpha.bioflux.io/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '961fdb61672a4684b06552d0974bd944',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files183955-alpha',
  aws_user_files_s3_bucket_region: 'us-east-2',
  aws_appsync_graphqlEndpoint:
    'https://3p4o3yfo6jeytghtmgjryhkahi.appsync-api.us-east-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};

const awsExportDelta: any = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:f8c49f59-acfc-4b22-863f-46492cd69b4f',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_CDUPT0Zjy',
  aws_user_pools_web_client_id: '35ltbjaf8mv0j5amhhn3rn4cpt',
  oauth: {
    domain: 'btcy-acc-delta.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://mercy.delta.bioflux.io/',
    redirectSignOut: 'https://mercy.delta.bioflux.io/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_mobile_analytics_app_id: '05d89e01e2134fdb82ecf4a73e3bf8b6',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files00045-delta',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportStaging = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:75b892cd-6e8b-4aa4-858d-c7141980437f',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_g3KOoWrsl',
  aws_user_pools_web_client_id: '4i48d2o7da73196jijhgq7mi3t',
  oauth: {
    domain: 'btcy-acc-staging.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://mercy.staging.biotricity.com/',
    redirectSignOut: 'https://mercy.staging.biotricity.com/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '90e74b7dac294e87a5d53ccfa6976191',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files170212-staging',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportCustomer = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:d330654d-a73b-4a6f-93ff-595169d13abc',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_wmg6yeYnW',
  aws_user_pools_web_client_id: '64djd7rnbjerhqh6qvac5fkcfo',
  oauth: {
    domain: 'biocare-customer.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://mercy.customer.biotricity.com/',
    redirectSignOut: 'https://mercy.customer.biotricity.com/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '31eb61bb696a4502814717d9669f3dc2',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-cardiac-user-files234733-customer',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

export { awsExportAlpha, awsExportDelta, awsExportStaging, awsExportCustomer };
